import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useCreateOffertaUtils from '../../../../hooks/useCreaOffertaUtils'
import useTrans from '../../../../hooks/useTrans'
import { api } from '../../../../utils'
import { PROFILOAZIENDA } from '../../../../utils/endpoint'
import { FormField } from '../../../atoms'
import Button from '../../../atoms/Button/Button'
import FormFile from '../../../atoms/FormFile/FormFile'
import FormSelect from '../../../atoms/FormSelect/FormSelect'
import LoadingSvg from '../../../atoms/Loading/Loading'
import { Bin } from '../../../atoms/NewIcons'
import { Input } from '../FormCreaOfferta'

const TuoiDati = ({ formik, setStep }) => {
  const router = useRouter()
  const { logoFile, logoId } = useSelector((state) => state?.creaofferta) || {}
  const { loading, fetchLoghi, loghi } = useCreateOffertaUtils()
  const dispatch = useDispatch()
  const t = useTrans()

  const _handleUpload = (e) => {
    formik?.setFieldValue('logoFile', e.target.files?.[0])
    dispatch({
      type: 'SAVE_LOGO_FILE',
      payload: { logoFile: { file: e.target.files?.[0], name: e.target.files?.[0]?.name } },
    })
  }

  const handleChangeOfUploadedLogo = (logoId) => {
    dispatch({
      type: 'SAVE_LOGO_ID',
      payload: { logoId: logoId },
    })
  }

  useEffect(() => {
    fetchLoghi()
  }, [])

  const isLogoValid = (logoId, logoFile) => {
    return !!(logoId || logoFile)
  }

  return (
    <div className={'container-form'}>
      <div className={'form-field-wrapper'}>
        <Input formik={formik} label={t('Nome*')} fieldName={'tuoi_dati.nome'} />
        <Input formik={formik} label={t('Indirizzo*')} fieldName={'tuoi_dati.indirizzo'} />
      </div>
      <div className={'form-field-wrapper'}>
        <Input formik={formik} label={t('E-Mail*')} fieldName={'tuoi_dati.email'} />
        <Input formik={formik} label={t('Telefono*')} fieldName={'tuoi_dati.telefono'} />
      </div>
      <div className={'form-field-wrapper'}>
        <Input
          formik={formik}
          label={t('Riferimento offerta*')}
          fieldName={'tuoi_dati.riferimento'}
        />
      </div>

      <div className={'form-field-wrapper'}>
        {loading ? (
          <LoadingSvg width={50} />
        ) : loghi?.length === 0 ? null : (
          <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
            <FormField label={t('Scegli tra i loghi caricati')}>
              <FormSelect
                placeholder={t('Seleziona logo già caricato')}
                value={formik?.values?.logo_id || logoId}
                onChange={(e) => {
                  handleChangeOfUploadedLogo(e?.target.value)
                  formik?.setFieldValue('logo_id', e?.target.value)
                }}
                options={loghi?.map((logo) => ({ label: logo?.logo_filename, value: logo?.id }))}
              />
            </FormField>
            <div
              style={{ marginLeft: 15, paddingTop: 15 }}
              onClick={() => formik?.setFieldValue('logo_id', null)}
            >
              {formik?.values?.logo_id && <Bin width={20} />}
            </div>
          </div>
        )}
      </div>

      {!loading && (
        <div className={'form-field-wrapper'}>
          {!formik?.values?.logo_id && (
            <FormField
              label={
                <span className="posizione__actions__top">
                  <span>{t('Logo per carta intestata*')}</span>
                </span>
              }
            >
              <FormFile
                placeholder={t('Carica il logo da applicare')}
                name={'logo_file_rea_offerta'}
                filename={logoFile?.name}
                onChange={_handleUpload}
              />
            </FormField>
          )}
        </div>
      )}

      <div className="form-field-button">
        <p style={{ margin: '15px 0px' }}>*{t('Campi obbligatori')}</p>
        <Button
          variant="primary"
          label={t('Conferma dati')}
          disabled={
            loading ||
            !!formik?.errors?.tuoi_dati ||
            (!router?.query?.editing ? !formik?.dirty : false) ||
            !isLogoValid(logoId, logoFile)
          }
          onClick={() => {
            dispatch({ type: 'SAVE_TUOI_DATI', payload: { tuoiDati: formik?.values?.tuoi_dati } })
            setStep((step) => step + 1)
          }}
        />
      </div>
    </div>
  )
}

export default TuoiDati
